import AnnouncementsPage from './announcements-page'

export default AnnouncementsPage
